<template>
  <div class="container ylcontainer">
    <div class="result_list">
      <div class="header">
        <div class="tit">
          <img src="../../assets/images/shopimg.png?v=1" />
        </div>
      </div>
      <div class="list" v-if="ismultiple">
        <van-checkbox-group v-model="resultlist">
          <div
            class="itembg"
            v-for="(item, index) in info.itemlist"
            :key="item.skuid"
          >
            <div class="item">
              <div class="ck">
                <van-checkbox
                  :disabled="
                    item.islimit != 0 || item.canbuycnt <= 0 || item.is_buy == 1
                  "
                  :name="item.skuid"
                  checked-color="#ffffff"
                >
                  <div class="proitem">
                    <img :src="item.img_path" />
                    <div
                      class="soldout"
                      v-if="item.islimit != 0 || item.canbuycnt <= 0"
                    ></div>
                    <div
                      class="goproductbtn"
                      @click="productDetailsFn(item)"
                    ></div>
                  </div>
                </van-checkbox>
              </div>
            </div>
          </div>
        </van-checkbox-group>
      </div>
      <div class="list" v-else-if="!ismultiple">
        <van-radio-group v-model="resultlist">
          <div
            class="itembg"
            v-for="(item, index) in info.itemlist"
            :key="item.skuid"
          >
            <div class="item">
              <div class="ck">
                <van-radio
                  :disabled="
                    item.islimit != 0 || item.canbuycnt <= 0 || item.is_buy == 1
                  "
                  :name="item.skuid"
                  checked-color="#ffffff"
                >
                  <div class="proitem">
                    <img :src="item.img_path" />
                    <div
                      class="soldout"
                      v-if="item.islimit != 0 || item.canbuycnt <= 0"
                    ></div>
                    <div
                      class="goproductbtn"
                      @click="productDetailsFn(item)"
                    ></div>
                  </div>
                </van-radio>
              </div>
            </div>
          </div>
        </van-radio-group>
      </div>
      <div class="ylrule">
        <img src="../../assets/images/jzdzlbrule.png?v=1" />
      </div>
      <div class="settlement">
        <div class="pro_tools">
          <div class="fl">
            <div class="pro_total_details">
              <div class="total">
                <div class="totalprice">
                  <div class="ppo">
                    <div class="totalname">福利价：</div>
                    <div class="smallprice">
                      <sub>¥</sub>{{ parseFloat(totalPrice).toFixed(2) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fr">
            <div class="btn" @click="settlement">
              <div class="gobuy">去结算</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="showshare" z-index="99"> </van-overlay>
    <div class="sharecontainer" v-if="showshare === true">
      <img src="../../assets/images/sharemc.png" />
      <van-button
        round
        plain
        type="danger"
        class="know"
        @click="showshare = false"
        >我知道了</van-button
      >
    </div>
    <div class="homeBtn" @click="homeClick">
      <img src="/static/images/homebtn.png" />
    </div>
  </div>
</template>

<script>
import {
  isWeixin,
  fenxiang,
  basepath,
  isApp,
  wxAjaxData,
  exclusiveidFn,
  pointParams
} from '../../assets/common/js/config'
import { Sku, Tag, Overlay } from 'vant'
import wx from 'weixin-js-sdk'
export default {
  name: 'community-promote-act',
  components: {
    [Sku.name]: Sku,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay
  },
  data: function() {
    return {
      actImgPath: '',
      showPresale: false,
      currentdiscount: 0,
      oldtotalmoney: 0,
      discounmoney: 0,
      currentfullgiftmoney: 0,
      saletotalmoney: 0,
      showofferdetails: false,
      showaction: false,
      msglist: [],
      presaledescpt: '',
      FlodMsg: '',
      discountrule: {},
      fullgiftrule: {},
      halfprice: {},
      resultlist: [],
      ismultiple: 0,
      showsku: false,
      info: {},
      list: [],
      nowPage: 1,
      pagesize: 10,
      noDataText: '————\n客官，么有啦~\n————',
      listItem: {},
      itemIndex: null,
      skuname: '',
      skuprice: '197.00-218.90',
      productId: null,
      maxNum: null,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: function(data) {
          const { action, limitType, quota, quotaUsed } = data
          if (action === 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action === 'plus') {
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 1999,
        stockFormatter: (stockNum) => {}
      },
      totalnum: 0,
      checked: true,
      showshare: false,
      shareUrl: basepath + '/Wxmall/WeChat/share' + wxAjaxData
    }
  },
  mounted: function() {
    this.getData()
  },
  beforeRouteEnter: function(to, from, next) {
    var boolvalue = true
    if (to.query.pt === 'app' && to.query.oper === 'login') {
      boolvalue = false
    } else if (from.path === '/code') {
      boolvalue = false
    } else if (from.path === '/order') {
      boolvalue = false
    }
    if (boolvalue) {
      // 当前页面刷新不需要切换位置
      localStorage.removeItem('skuids')
      localStorage.removeItem('buynum')
      localStorage.removeItem('itemid')
      next()
    } else {
      localStorage.removeItem('skuids')
      localStorage.removeItem('buynum')
      localStorage.removeItem('itemid')
      next()
    }
  },
  computed: {
    checkAlled: function() {
      if (this.info.itemlist && this.info.itemlist.length > 0) {
        if (typeof this.resultlist !== 'string') {
          if (this.info.itemlist.length <= this.resultlist.length) {
            return true
          }
        }
        return false
      }
    },
    totalPrice: function() {
      var that = this
      var Price = 0
      that.totalnum = 0
      var goodsnum = 0
      var money = 0
      that.oldtotalmoney = 0
      that.saletotalmoney = 0
      that.discounmoney = 0
      that.currentdiscount = 0
      that.FlodMsg = ''
      if (that.info.itemlist && that.info.itemlist.length > 0) {
        that.info.itemlist.forEach(function(good, i) {
          console.log(that.resultlist)
          if (typeof that.resultlist != 'string') {
            that.resultlist.forEach(function(item, index) {
              if (item === good.skuid) {
                Price =
                  Price + parseFloat(good.sales_price) * parseInt(good.num)
                that.oldtotalmoney +=
                  parseFloat(good.cost_price) * parseInt(good.num)
                that.saletotalmoney +=
                  parseFloat(good.sales_price) * parseInt(good.num)
                that.totalnum = that.totalnum + parseInt(good.num)
                if (good.isdiscount == 1) {
                  goodsnum += parseInt(good.num)
                  money += parseFloat(good.sales_price) * parseInt(good.num)
                }
              }
            })
          } else {
            if (that.resultlist == good.skuid) {
              Price = Price + parseFloat(good.sales_price) * parseInt(good.num)
              that.oldtotalmoney +=
                parseFloat(good.cost_price) * parseInt(good.num)
              that.saletotalmoney +=
                parseFloat(good.sales_price) * parseInt(good.num)
              that.totalnum = that.totalnum + parseInt(good.num)
              if (good.isdiscount == 1) {
                goodsnum += parseInt(good.num)
                money += parseFloat(good.sales_price) * parseInt(good.num)
              }
            }
          }
        })
        // 折上折
        if (that.discountrule && that.discountrule.discountenable == 1) {
          var discountlist = that.discountrule.discountlist
          if (parseInt(goodsnum) == 0) {
            var discount = discountlist[0].discount
            var txt =
              (discount * 100) % 10 == 0
                ? (discount * 100) / 10
                : discount * 100
            that.FlodMsg = '惊喜！选购活动商品最高可享受' + txt + '折'
            that.currentdiscount = 1
          } else if (parseInt(goodsnum) >= parseInt(discountlist[0].itemnum)) {
            var discount = discountlist[0].discount
            var txt =
              (discount * 100) % 10 == 0
                ? (discount * 100) / 10
                : discount * 100
            if (
              that.fullgiftrule.actstatus &&
              parseInt(that.fullgiftrule.actstatus) == 1
            ) {
              that.FlodMsg = ''
            } else {
              that.FlodMsg = '惊喜！已选' + goodsnum + '件享' + txt + '折'
            }
            that.currentdiscount = discount
          } else if (
            parseInt(goodsnum) <
            parseInt(discountlist[discountlist.length - 1].itemnum)
          ) {
            var discount1 = discountlist[discountlist.length - 1].discount
            var txt =
              (discount1 * 100) % 10 == 0
                ? (discount1 * 100) / 10
                : discount1 * 100
            that.FlodMsg =
              '惊喜！已选' +
              goodsnum +
              '件，再加' +
              (parseInt(discountlist[discountlist.length - 1].itemnum) -
                goodsnum) +
              '件即可享受' +
              txt +
              '折。'
            that.currentdiscount = 1
          } else {
            try {
              discountlist.forEach(function(item, index) {
                if (parseInt(goodsnum) >= parseInt(item.itemnum)) {
                  var discount1 = item.discount
                  var discount2 = discountlist[index - 1].discount
                  var txt =
                    (discount1 * 100) % 10 == 0
                      ? (discount1 * 100) / 10
                      : discount1 * 100
                  var txt1 =
                    (discount2 * 100) % 10 == 0
                      ? (discount2 * 100) / 10
                      : discount2 * 100
                  that.FlodMsg =
                    '惊喜！已选' +
                    goodsnum +
                    '件享' +
                    txt +
                    '折，再加' +
                    (parseInt(discountlist[index - 1].itemnum) - goodsnum) +
                    '件即可享受' +
                    txt1 +
                    '折。'
                  that.currentdiscount = discount1
                  throw new Error()
                }
              })
            } catch (e) {}
          }
        }
        if (that.currentdiscount > 0) {
          Price = Price * that.currentdiscount
          that.discounmoney = that.saletotalmoney - Price
        }
      }
      return Price
    },
    fullGiftMsg: function() {
      var that = this
      var fullGiftMsg = ''
      if (
        that.fullgiftrule &&
        parseInt(that.fullgiftrule.actstatus) == 1 &&
        !that.FlodMsg
      ) {
        if (
          this.fullgiftrule.rulelist &&
          this.fullgiftrule.rulelist.length > 0
        ) {
          var rulelist = this.fullgiftrule.rulelist
          var price = 0
          that.isChooseProduct.forEach(function(item) {
            if (item.isfullgift == 1) {
              if (parseInt(item.isdiscount) == 1 && that.currentdiscount > 0) {
                price +=
                  Number(item.sales_price) *
                  parseInt(item.num) *
                  Number(that.currentdiscount)
              } else {
                price += Number(item.sales_price) * parseInt(item.num)
              }
            }
          })
          that.currentfullgiftmoney = parseFloat(price).toFixed(2)
          if (!isNaN(Number(that.currentfullgiftmoney))) {
            if (
              parseFloat(that.currentfullgiftmoney) == 0 ||
              parseFloat(that.currentfullgiftmoney) <
                parseFloat(rulelist[rulelist.length - 1].allmoney)
            ) {
              var m = !isNaN(Number(rulelist[rulelist.length - 1].allmoney))
                ? parseFloat(
                    Number(rulelist[rulelist.length - 1].allmoney) -
                      Number(that.currentfullgiftmoney)
                  ).toFixed(2)
                : '0.00'
              var m1 = !isNaN(
                parseFloat(rulelist[rulelist.length - 1].senditemprice)
              )
                ? parseFloat(
                    rulelist[rulelist.length - 1].senditemprice
                  ).toFixed(2)
                : '0.00'
              fullGiftMsg =
                '惊喜！还差<span>' +
                m +
                '</span>元，即送价值<span>' +
                m1 +
                '</span>元' +
                rulelist[rulelist.length - 1].senditemname
            } else if (
              parseFloat(that.currentfullgiftmoney) >=
              parseFloat(rulelist[0].allmoney)
            ) {
              var m = !isNaN(parseFloat(rulelist[0].allmoney))
                ? parseFloat(rulelist[0].allmoney).toFixed(2)
                : '0.00'
              var m1 = !isNaN(parseFloat(rulelist[0].senditemprice))
                ? parseFloat(rulelist[0].senditemprice).toFixed(2)
                : '0.00'
              fullGiftMsg =
                '惊喜！已满<span>' +
                m +
                '</span>元，可领价值<span>' +
                m1 +
                '</span>元' +
                rulelist[0].senditemname
            } else {
              try {
                rulelist.forEach(function(item, index) {
                  if (
                    parseFloat(that.currentfullgiftmoney) >=
                    parseFloat(item.allmoney)
                  ) {
                    var m = !isNaN(parseFloat(rulelist[index - 1].allmoney))
                      ? parseFloat(
                          Number(rulelist[index - 1].allmoney) -
                            Number(that.currentfullgiftmoney)
                        ).toFixed(2)
                      : '0.00'
                    var m1 = !isNaN(
                      parseFloat(rulelist[index - 1].senditemprice)
                    )
                      ? parseFloat(rulelist[index - 1].senditemprice).toFixed(2)
                      : '0.00'
                    fullGiftMsg =
                      '惊喜！还差<span>' +
                      m +
                      '</span>元，即送价值<span>' +
                      m1 +
                      '</span>元' +
                      rulelist[index - 1].senditemname
                    throw new Error()
                  }
                })
              } catch (e) {}
            }
            return fullGiftMsg
          }
        }
      }
    },
    isChooseProduct: function() {
      var that = this
      var list = []
      if (that.info.itemlist && that.info.itemlist.length > 0) {
        that.info.itemlist.forEach(function(good, i) {
          if (typeof that.resultlist !== 'string') {
            that.resultlist.forEach(function(item, index) {
              if (item === good.skuid) {
                list.push(good)
              }
            })
          } else if (that.resultlist === good.skuid) {
            list.push(good)
          }
        })
      }
      return list
    }
  },
  methods: {
    getData: function() {
      var that = this
      var arg = isApp()
      var url = this.$ajax.getJzGiftActIndex_URL
      if (arg == '') {
        if (isWeixin()) {
          fenxiang({ path: 'jzdzlbindex' })
        }
      }
      this.$customRequestAjax(url).then(function(res) {
        if (res.data.code == 200) {
          that.ismultiple = +res.data.ismultiple
          if (that.ismultiple) {
            that.resultlist = []
          } else {
            that.resultlist = ''
          }
          that.actImgPath = res.data.act_banner
          var skuids = []
          if (localStorage.getItem('skuids')) {
            skuids = JSON.parse(localStorage.getItem('skuids'))
            that.resultlist = skuids
          }
          var buynum = []
          if (localStorage.getItem('buynum')) {
            buynum = JSON.parse(localStorage.getItem('buynum'))
          }
          var itemids = []
          if (localStorage.getItem('buynum')) {
            itemids = JSON.parse(localStorage.getItem('itemid'))
          }
          var items = []
          var resultitems = []
          console.log('res.data.itemlist', res.data.itemlist)
          res.data.itemlist.map(function(item, index) {
            item.img_path =
              '../../../static/images/lbact/jzfxlb' +
              (parseInt(index) + 1) +
              '.png?v=1'
            console.log(index, item.img_path)
            console.log('skuids', skuids, 'itemids', itemids)
            skuids.forEach(function(skuid, i) {
              if (item.itembaseid === itemids[i]) {
                item.sku_rule_list.forEach(function(good, j) {
                  console.log('item.sku_rule_list', item.sku_rule_list)
                  if (good.skuid === skuid) {
                    item.skuid = good.skuid
                    item.spec = good.sku_name
                    item.sales_price = good.sales_price
                    item.cost_price = good.cost_price
                    item.path = good.spec_imgpath
                    item.islimit = good.islimit
                    item.issale = good.issale
                    item.canbuycnt = good.canbuycnt
                    item.lib_warning = good.lib_warning
                    item.num = buynum[i]
                  }
                })
              } else {
                if (item.skuid === skuid) {
                  item.num = buynum[i]
                }
              }
            })
            if (!item.num) {
              item.num = 1
            }
            items.push(item)
            resultitems.push(item.skuid)
          })
          if (
            res.data.itemlist.length == 1 &&
            typeof that.resultlist != 'string'
          ) {
            if (
              !(
                res.data.itemlist[0].islimit != 0 ||
                res.data.itemlist[0].canbuycnt <= 0 ||
                res.data.itemlist[0].is_buy == 1
              )
            ) {
              that.resultlist = [res.data.itemlist[0].skuid]
            }
          }
          that.info = res.data
          that.info.itemlist = items
          that.list = that.info.itemlist
          that.discountrule = res.data.discountrule
          that.halfprice = {
            halfpricestatus: res.data.halfpricestatus,
            halfpricedesc: res.data.halfpricedesc,
            halfactname: res.data.halfactname,
            halfactlabel: res.data.halfactlabel
          }
          that.presaledescpt = res.data.presaledescpt
          that.fullgiftrule = res.data.fullgiftrule
          if (typeof that.resultlist != 'string') {
            that.resultlist = resultitems
          }
        } else {
        }
      })
    },
    share: function() {
      var arg = isApp()
      if (arg == '') {
        if (isWeixin()) {
          this.showshare = true
        } else {
          this.$toast('关注【创客村】公众号，惊喜享不停')
        }
      } else if (arg.indexOf('xcx') < 0) {
        var usescope = '我已为你锁定3.8健肤礼，爆款护肤好物，平台亿元让利。'
        var img = basepath + '/static/images/ylshareimg.png'
        var obj = {
          type: 'shareFriends',
          title: encodeURIComponent('29.9元秒杀护肤壕礼'),
          img: img,
          desc: encodeURIComponent(usescope),
          link: encodeURIComponent(this.shareUrl + '&type=drainage')
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      }
    },
    productDetailsFn: function(items) {
      console.log(items)
      if (items.islimit != 0 || items.canbuycnt <= 0) {
        return
      }
      var arg = isApp()
      if (arg == '') {
        this.$router.push({
          path: '/jzdzlbproduct',
          query: {
            itemid: items.itembaseid
          }
        })
      } else {
        this.$router.push(
          '/jzdzlbproduct?' + arg + '&itemid=' + items.itembaseid
        )
      }
    },
    homeClick: function() {
      var arg = isApp()
      if (arg == '') {
        this.$router.replace('/')
      } else if (arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goIndex'
          })
        )
      } else {
        wx.miniProgram.reLaunch({
          url:
            '/pages/index/main?exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      }
    },
    handleCheckedAll: function() {
      if (this.checked === false) {
        var items = []
        this.info.itemlist.forEach(function(item, index) {
          items.push(item.skuid)
        })
        this.resultlist = items
      } else {
        this.resultlist = ''
      }
    },
    onConfirmClicked: function() {
      var skuData = this.$refs.sku.getSkuData()
      var that = this
      var resultlist = ''
      console.log(skuData.selectedSkuComb)
      if (!skuData.selectedSkuComb) {
        return
      }
      if (typeof this.resultlist == 'string') {
        if (this.resultlist == that.listItem.skuid) {
          this.resultlist = skuData.selectedSkuComb.id
        }
        resultlist = this.resultlist
      } else {
        this.resultlist.forEach(function(item, index) {
          if (this.resultlist == that.listItem.skuid) {
            this.resultlist = skuData.selectedSkuComb.id
          }
          resultlist = this.resultlist
        })
      }
      this.resultlist = resultlist
      if (skuData.selectedSkuComb.id !== that.listItem.skuid) {
        that.$nextTick(function() {
          that.initialSku = skuData.selectedSkuComb
          that.initialSku['selectedNum'] = skuData.selectedNum
        })
        that.info.itemlist[that.itemIndex].islimit =
          skuData.selectedSkuComb.stock_num > 0 ? 0 : 1
        that.info.itemlist[that.itemIndex].spec = that.skuname
        that.info.itemlist[that.itemIndex].sales_price =
          skuData.selectedSkuComb.price
        that.info.itemlist[that.itemIndex].skuid = skuData.selectedSkuComb.id
      }
      this.showsku = false
    },
    settlement: function() {
      var that = this
      var arg = isApp()
      if (that.info.act_status == 1) {
        that.$dialog
          .confirm({
            message: '活动还未开始，等会再来吧',
            confirmButtonText: '去首页',
            className: 'percen_button_alert',
            confirmButtonColor: '#FFFCFC',
            closeOnPopstate: true
          })
          .then(function() {
            // 点击确认按钮
            var arg = isApp()
            if (arg == '') {
              that.$router.replace('/')
            } else if (arg.indexOf('xcx') < 0) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: 'goIndex'
                })
              )
            } else {
              wx.miniProgram.reLaunch({
                url:
                  '/pages/index/main?exclusiveid=' +
                  exclusiveidFn() +
                  pointParams('&')
              })
            }
          })
          .catch(function() {})
        return
      } else if (that.info.act_status == 2) {
        that.$dialog
          .confirm({
            title: '来晚了',
            message: '活动已结束，去看看其他的活动吧',
            confirmButtonText: '去首页',
            className: 'percen_button_alert',
            confirmButtonColor: '#FFFCFC',
            closeOnPopstate: true
          })
          .then(function() {
            // 点击确认按钮
            var arg = isApp()
            if (arg == '') {
              that.$router.replace('/')
            } else if (arg.indexOf('xcx') < 0) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: 'goIndex'
                })
              )
            } else {
              wx.miniProgram.reLaunch({
                url:
                  '/pages/index/main?exclusiveid=' +
                  exclusiveidFn() +
                  pointParams('&')
              })
            }
          })
          .catch(function() {})
        return
      } else if (that.info.act_status == 3) {
        that.$dialog
          .confirm({
            message: '您已经抢过了，给别人留点吧，还可看看其他活动',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '去逛逛'
          })
          .then(function() {
            var arg = isApp()
            if (arg == '') {
              that.$router.replace({
                path: '/classification',
                query: {
                  type: 'inside'
                }
              })
            } else if (arg.indexOf('xcx') < 0) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: 'goCategroy'
                })
              )
            } else {
              wx.miniProgram.reLaunch({
                url:
                  '/pages/categroy/main?exclusiveid=' +
                  exclusiveidFn() +
                  pointParams('&')
              })
            }
          })
          .catch(function() {})
        return
      }
      var skuids = that.isChooseProduct.map(function(item) {
        return item.skuid
      })
      var buynum = that.isChooseProduct.map(function(item) {
        return item.num
      })
      var itemid = that.isChooseProduct.map(function(item) {
        return item.itembaseid
      })

      var liveId = [0]
      var ispresale = 0
      that.isChooseProduct.forEach(function(item) {
        if (item.ispresale == 1) {
          ispresale = 1
        }
      })
      if (that.isChooseProduct && that.isChooseProduct.length > 0) {
        if (!isWeixin()) {
          // 非微信浏览器情况
          if (arg == '') {
            if (
              this.waptoken.waptoken &&
              this.waptoken.waptoken === this.waptoken.tourists
            ) {
              // 未登录情况逻辑处理
              this.$router.push({
                path: '/login',
                query: {
                  routeval: 'jzdzlbindex'
                }
              })
              localStorage.setItem('skuids', JSON.stringify(skuids))
              localStorage.setItem('buynum', JSON.stringify(buynum))
              localStorage.setItem('itemid', JSON.stringify(itemid))
              localStorage.setItem('liveId', JSON.stringify(liveId))
              return
            }
          }
          localStorage.setItem('skuids', JSON.stringify(skuids))
          localStorage.setItem('buynum', JSON.stringify(buynum))
          localStorage.setItem('itemid', JSON.stringify(itemid))
          localStorage.setItem('liveId', JSON.stringify(liveId))
          // that.handleJoinData()
          that.checkJzGiftAct()
        } else {
          // 微信浏览器情况
          localStorage.setItem('skuids', JSON.stringify(skuids))
          localStorage.setItem('buynum', JSON.stringify(buynum))
          localStorage.setItem('itemid', JSON.stringify(itemid))
          localStorage.setItem('liveId', JSON.stringify(liveId))
          that.checkJzGiftAct()
          // that.handleJoinData()
        }
      } else {
        var i = 0
        that.info.itemlist.map(function(item) {
          if (item.islimit != 0 || item.canbuycnt <= 0) {
            i++
          }
        })
        if (i >= that.info.itemlist.length) {
          that
            .$dialog({
              message: '来晚了，商品已经售罄了，下次早点来吧',
              className: 'percen_button_alert',
              confirmButtonText: '知道了'
            })
            .then(function() {
              // on confirm
            })
        } else {
          that.$toast('请选择需要购买的商品')
        }
      }
    },
    // 检验是否有购买资格
    checkJzGiftAct() {
      this.$customRequestAjax(this.$ajax.checkJzGiftAct_URL).then((res) => {
        if (res.data.code === 200) {
          this.handleJoinData()
        } else {
          this.$toast(res.data.msg)
        }
      })
    },
    handleJoinData: function() {
      var that = this
      var arg = isApp()
      var shopConfirmResult = {
        skuidArr: [],
        itemNum: [],
        skuidArrOversea: [],
        from: 2, // 购物车：0；立即购买：1；皮肤测试：3
        orderfrom: 1,
        itemNumOversea: [],
        itemidArr: [],
        totalmoney: that.totalPrice,
        totalnum: that.totalnum,
        liveId: [0]
      }
      var ispresale = 0
      that.isChooseProduct.forEach(function(item) {
        if (item.isoversea === 1) {
          shopConfirmResult.itemidArr.push(item.itembaseid)
          shopConfirmResult.skuidArrOversea.push(item.skuid)
          shopConfirmResult.itemNumOversea.push(item.num)
        } else {
          shopConfirmResult.itemidArr.push(item.itembaseid)
          shopConfirmResult.skuidArr.push(item.skuid)
          shopConfirmResult.itemNum.push(item.num)
        }
        if (item.ispresale == 1) {
          ispresale = 1
        }
      })
      if (
        shopConfirmResult.skuidArr.length > 0 &&
        shopConfirmResult.skuidArrOversea.length <= 0
      ) {
        if (
          this.showPresale == false &&
          ispresale == 1 &&
          !localStorage.getItem('compresale')
        ) {
          that.showPresale = true
          localStorage.setItem('compresale', '1')
        } else {
          localStorage.setItem(
            'shopConfirmResult',
            JSON.stringify(shopConfirmResult)
          )
          sessionStorage.removeItem('choose_integral')
          sessionStorage.removeItem('choose_coupon')
          sessionStorage.removeItem('choose_product')
          sessionStorage.removeItem('oversea_List')
          that.dataCollection('buyNow')
          if (arg == '') {
            that.$router.push('/order?yl=1&lb=1')
          } else if (arg.indexOf('xcx') < 0) {
            var obj = {
              type: 'lbBuy',
              skuids: shopConfirmResult.skuidArr.join(),
              item_num: shopConfirmResult.itemNum.join(),
              from: shopConfirmResult.from
            }
            that.$commonburiedPoint({
              data: {
                scenepoint: window.document.title,
                scenedesc: window.location.href,
                url: 'order-confirm'
              },
              rnType: 'lbBuy',
              callback: () => {
                window.ReactNativeWebView.postMessage(JSON.stringify(obj))
              }
            })
          } else {
            shopConfirmResult.orderHadOnShow = 0
            shopConfirmResult.isInitData = 1
            shopConfirmResult.live_id = ''
            shopConfirmResult.type = 'lbBuy'
            console.log(shopConfirmResult)
            wx.miniProgram.navigateTo({
              url:
                '/pages/order/main?yl=1&lb=1&shopConfirmResult=' +
                JSON.stringify(shopConfirmResult) +
                '&scenepoint=' +
                encodeURIComponent(window.document.title) +
                '&exclusiveid=' +
                exclusiveidFn() +
                pointParams('&')
            })
          }
        }
      } else if (
        shopConfirmResult.skuidArrOversea.length > 0 &&
        shopConfirmResult.skuidArr.length <= 0
      ) {
        if (
          this.showPresale == false &&
          ispresale == 1 &&
          !localStorage.getItem('compresale')
        ) {
          that.showPresale = true
          localStorage.setItem('compresale', '1')
        } else {
          // 为了使普通商品和海外商品的确认订单接口参数key值保持一致
          shopConfirmResult.skuidArr = shopConfirmResult.skuidArrOversea
          shopConfirmResult.itemNum = shopConfirmResult.itemNumOversea
          shopConfirmResult.skuidArrOversea = []
          shopConfirmResult.itemNumOversea = []

          localStorage.setItem(
            'shopConfirmResult',
            JSON.stringify(shopConfirmResult)
          )
          sessionStorage.removeItem('choose_integral')
          sessionStorage.removeItem('choose_coupon')
          sessionStorage.removeItem('choose_product')
          sessionStorage.removeItem('oversea_List')
          if (arg == '') {
            that.$router.push('/order?yl=1&lb=1')
          } else if (arg.indexOf('xcx') < 0) {
            var obj = {
              type: 'lbBuy',
              skuids: shopConfirmResult.skuidArr.join(),
              item_num: shopConfirmResult.itemNum.join(),
              from: shopConfirmResult.from
            }
            that.$commonburiedPoint({
              data: {
                scenepoint: window.document.title,
                scenedesc: window.location.href,
                url: 'order-confirm'
              },
              rnType: 'lbBuy',
              callback: () => {
                window.ReactNativeWebView.postMessage(JSON.stringify(obj))
              }
            })
          } else {
            shopConfirmResult.orderHadOnShow = 0
            shopConfirmResult.isInitData = 1
            shopConfirmResult.live_id = ''
            shopConfirmResult.type = 'lbBuy'
            console.log(shopConfirmResult)
            wx.miniProgram.navigateTo({
              url:
                '/pages/order/main?yl=1&lb=1&shopConfirmResult=' +
                JSON.stringify(shopConfirmResult) +
                '&scenepoint=' +
                encodeURIComponent(window.document.title) +
                '&exclusiveid=' +
                exclusiveidFn() +
                pointParams('&')
            })
          }
        }
      } else {
        that.$toast('海外商品不能与普通商品一起购买')
      }
    },
    showActDesc: function(obj) {
      var that = this
      that.msglist = []
      if (
        that.discountrule &&
        that.discountrule.discountenable == 1 &&
        that.discountrule.discountlist &&
        obj.isdiscount == 1
      ) {
        var msg = []
        that.discountrule.discountlist.forEach(function(item, index) {
          var txt =
            (item.discount * 100) % 10 == 0
              ? (item.discount * 100) / 10
              : item.discount * 100
          msg.push(item.itemnum + '件' + txt + '折')
        })
        var discountruledesc = '满' + msg.join(',')
        that.msglist.push({
          enable: that.discountrule.discountenable,
          shortdesc: discountruledesc,
          desc: that.discountrule.discountdescription,
          name: that.discountrule.name,
          actlabel: that.discountrule.actlabel
        })
      }
      if (
        that.fullgiftrule &&
        that.fullgiftrule.actstatus == 1 &&
        that.fullgiftrule.rulelist &&
        obj.isfullgift == 1
      ) {
        that.msglist.push({
          enable: that.fullgiftrule.actstatus,
          shortdesc: that.fullgiftrule.actdesc,
          desc: that.fullgiftrule.actdesc,
          name: that.fullgiftrule.actname,
          actlabel: that.fullgiftrule.actlabel
        })
      }
      if (that.halfprice.halfpricestatus == 1) {
        that.msglist.push({
          enable: that.halfprice.halfpricestatus,
          shortdesc: that.halfprice.halfpricedesc,
          desc: that.halfprice.halfpricedesc,
          name: that.halfprice.halfactname,
          actlabel: that.halfprice.halfactlabel
        })
      }
      that.showaction = true
    },
    // 埋点
    dataCollection(dataType) {
      let params = {
        productId_var: this.isChooseProduct[0].itembaseid, // 商品id
        productName_var: this.isChooseProduct[0].name, // 商品名称
        firstCat_var: '', // 商品以及分类
        productType_var: '', // 商品品类
        productFormat_var: this.isChooseProduct[0].skuid // 商品规格
      }
      console.log(params)
      gio('track', dataType, params)
    }
  },
  filters: {
    salespricepositive: function(value) {
      return parseInt(value)
    },
    salespricedecimal: function(value) {
      var v = parseFloat(value).toFixed(2) + ''
      v = v.substring(v.indexOf('.') + 1)
      return v
    }
  },
  watch: {
    checkAlled(val) {
      this.checked = val
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #780700;
  .result_tit {
    position: absolute;
    top: 0.15rem;
    left: 0;
    width: 100%;
    img {
      width: 2.48rem;
      height: 0.52rem;
      margin: 0 auto;
    }
  }

  .result_list {
    position: relative;
    .header {
      position: relative;
      width: 100%;
      z-index: 0;
      margin-bottom: -1rem;
      img {
        width: 100%;
      }
      .share {
        font-size: 0;
        text-align: center;
        position: absolute;
        bottom: 0.03rem;
        right: 0;
        left: 0;
        .btn {
          margin: 0 auto;
          display: inline-block;
          min-width: 1.35rem;
          height: 0.4rem;
          color: #333;
          font-size: 0.16rem;
          background: url('../../../static/images/38act/ylfxbtn.png') no-repeat
            center;
          background-size: 100%;
          border-radius: 0.2rem;
          line-height: 0.4rem;
          text-align: center;
        }
      }
    }
    .list {
      width: 100%;
      z-index: 1;
      padding: 0 0.11rem;
      .itembg {
        border-radius: 0.04rem;
        padding: 0.1rem 0.11rem 0;
        padding-left: 0;
        &:last-of-type {
          margin-bottom: 0.15rem;
        }
        .item {
          display: flex;
          display: -o-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -webkit-flex;
          align-items: center;
          -o-align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -webkit-align-items: center;
          .proitem {
            position: relative;
            display: flex;
            display: -o-flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            align-items: flex-start;
            -o-align-items: flex-start;
            -moz-align-items: flex-start;
            -ms-align-items: flex-start;
            -webkit-align-items: flex-start;
            flex: 1;
            -webkit-flex: 1;
            -o-flex: 1;
            -moz-flex: 1;
            -ms-flex: 1;
            .img {
              margin-left: 0.08rem;
              img {
                width: 0.85rem;
                height: 0.85rem;
              }
            }
            .con {
              width: 100%;
              margin-left: 0.07rem;
              height: 0.85rem;
              position: relative;
              .tit {
                font-size: 0.13rem;
                color: #292929;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin-top: 0.04rem;
              }
              .spec {
                font-size: 0.11rem;
                color: #6c6c6c;
                margin-top: 0.03rem;
                height: 0.19rem;
                .spec_con {
                  float: left;
                  background: #f6f6f6;
                  border-radius: 0.1rem;
                  padding: 0.01rem 0.07rem;
                  line-height: 0.16rem;
                  padding-bottom: 0.02rem;
                  display: flex;
                  align-content: center;
                  align-items: center;
                  .van-icon {
                    font-size: 0.09rem;
                    margin-left: 0.03rem;
                  }
                }
              }
              .priceAndnum {
                position: absolute;
                bottom: 0.15rem;
                left: 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .price {
                  display: flex;
                  align-items: center;
                  line-height: 0.13rem;
                  color: #e22a41;
                  font-size: 0.16rem;
                  .fh {
                    font-size: 0.13rem;
                    line-height: 0.13rem;
                  }
                  .positive {
                    font-size: 0.16rem;
                    font-weight: 600;
                    line-height: 0.13rem;
                  }
                  .dian {
                    font-size: 0.15rem;
                    line-height: 0.13rem;
                  }
                  .decimal {
                    font-size: 0.13rem;
                    line-height: 0.13rem;
                  }
                }
                .dialog {
                  font-size: 0.16rem;
                  color: #e22a41;
                }
              }
            }
            > img {
              width: 100%;
              position: relative;
            }
            .soldout {
              border-radius: 0.1rem;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              background: rgba(223, 223, 223, 0.63)
                url('../../../static/images/38act/soldout.png') no-repeat 0.6rem
                center;
              background-size: 0.71rem;
            }
            .goproductbtn {
              width: 0.55rem;
              height: 0.55rem;
              position: absolute;
              right: 0.13rem;
              top: 0.08rem;
            }
          }
        }
        .act_desc_tag {
          font-size: 0.12rem;
          margin-top: 0.08rem;
          margin-left: 0.28rem;
          .van-icon-arrow {
            float: right;
          }
        }
        .act_desc_time {
          font-size: 0.11rem;
          margin-left: 0.28rem;
          color: #f12a0e;
          margin-top: 0.04rem;
          display: flex;
          align-items: center;
          img {
            width: 0.12rem;
          }
          .txt {
            font-size: 0.12rem;
            color: #f12a0e;
            transform: scale(0.92, 0.92);
            margin-left: -0.03rem;
            line-height: 0.17rem;
          }
        }
        .act_desc_time .van-icon-warning-o {
          float: left;
          font-size: 0.16rem;
          display: block;
          margin-right: 0.04rem;
        }
        .act_desc {
          font-size: 0.12rem;
          transform: scale(0.8);
          margin-top: 0.04rem;
          color: #fc0324;
        }
      }
    }
    .ylrule {
      color: #ffffff;
      margin-bottom: 0.8rem;
      margin-top: 0.3rem;
      position: relative;
      z-index: 1;
      img {
        width: 100%;
      }
    }
    .settlement {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 98;
      background: #650600;
      .pro_tools:before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        transform: translateY(-50%);
        content: '';
      }
      .pro_tools {
        position: relative;
        height: 0.52rem;
        font-size: 0.12rem;
        display: flex;
        align-content: center;
        justify-content: space-between;
        padding-left: 0.16rem;
        padding-right: 0.12rem;
      }
      .fl {
        display: flex;
        align-content: center;
      }
      .pro_total_details {
        float: left;
        font-size: 0.12rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        .offerdetails {
          margin-left: 0.01rem;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .flp {
            font-size: 0.11rem;
            color: #fc0324;
            margin-left: 0.01rem;
            transform: scale(0.9, 0.9);
            float: left;
          }
          img {
            float: left;
            width: 0.11rem;
            vertical-align: middle;
          }
        }
        .total {
          .totalname {
            font-size: 0.13rem;
            color: #ffffff;
            float: left;
          }
          .totalprice {
            float: left;
            display: flex;
          }
          .ppo {
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
          .oldprice {
            margin-left: 0.025rem;
            font-size: 0.1rem;
            color: #8b8b8b;
            text-decoration: line-through;
          }
          .smallprice {
            color: #ffffff;
            font-size: 0.15rem;
            font-weight: bold;
          }
          sub {
            font-weight: normal;
            font-size: 0.15rem;
            vertical-align: baseline;
          }
        }
      }
      .btn {
        display: flex;
        align-items: center;
        height: 0.52rem;
        .gobuy {
          padding: 0 0.05rem;
          font-size: 0.13rem;
          color: #ffffff;
          text-align: center;
          line-height: 0.33rem;
          min-width: 0.875rem;
          height: 0.33rem;
          background: #a10408;
          border-radius: 0.2125rem;
        }
      }
    }
  }
  .offer.van-popup--bottom {
    bottom: 0.44rem;
  }
  .van-action-sheet__close {
    background: url('../../assets/images/closex.png') center no-repeat;
    background-size: 0.2rem 0.2rem;
  }
  .van-action_model {
    height: 70vh;
    .van-item {
      padding: 0.14rem;
      .tit {
        font-size: 0.14rem;
        color: #262626;
        font-weight: 400;
        line-height: 0.23rem;
      }
      .con {
        padding-top: 0.1rem;
        line-height: 0.23rem;
        font-size: 0.13rem;
        color: #333333;
      }
    }
    .btn {
      padding: 0.14rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      .vanbtn {
        width: 100%;
        height: 0.43rem;
        background: linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(246, 58, 102, 1) 100%
        );
        border-radius: 0.25rem;
      }
    }
  }
  .presale_info_dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3001;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    .dialog {
      width: 79%;
      margin: 0 auto;
      background: #fff;
      border-radius: 0.04rem;
      height: 2.24rem;
      position: relative;
      .header1 {
        width: 70%;
        margin: 0 auto;
        font-weight: bold;
        .van-divider {
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          align-items: center;
          margin: 0.2rem 0;
          line-height: 0.24rem;
          border-color: #666666;
          border-style: solid;
          border-width: 0;
          color: #333333;
          font-size: 0.21rem;
        }
        .van-divider::before,
        .van-divider::after {
          content: ' ';
          display: block;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          flex: 1;
          box-sizing: border-box;
          height: 1px;
          border-color: inherit;
          border-style: inherit;
          border-width: 0 0 0;
          margin-right: 0.16rem;
          margin-left: 0.16rem;
        }
      }
      .content {
        width: 80%;
        margin: 0 auto;
        text-align: center;
        color: #444444;
        font-size: 0.14rem;
        margin-top: 0.02rem;
        line-height: 0.2rem;
        height: 1.2rem;
        overflow-y: auto;
      }
      .btn {
        background: #fc0324;
        width: 50%;
        text-align: center;
        color: #fff;
        font-size: 0.15rem;
        border-radius: 0.16rem;
        height: 0.31rem;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 25%;
        bottom: 0.22rem;
      }
    }
  }
  .additemMsg {
    position: fixed;
    left: 0;
    bottom: 0.52rem;
    width: 100%;
    padding: 0.15rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    z-index: 10;
    .msg {
      font-size: 0.12rem;
      line-height: 0.14rem;
      color: #333333;
      display: flex;
      align-items: center;
      img {
        width: 0.13rem;
        margin-right: 0.06rem;
      }
    }
    .btn {
      font-size: 0.12rem;
      color: #ff253e;
      white-space: nowrap;
      margin-left: 0.08rem;
    }
  }
  .sharecontainer {
    position: fixed;
    width: 100%;
    z-index: 100;
    height: 100%;
    left: 0;
    top: 0;
    img {
      position: absolute;
      top: 0;
      right: 0.35rem;
      width: 1.53rem;
    }
    .know {
      width: 1.09rem;
      height: 0.36rem;
      line-height: 0.36rem;
      color: #fff;
      border-color: #fff;
      background: transparent;
      position: absolute;
      bottom: 1.5rem;
      left: 50%;
      margin-left: -0.54rem;
    }
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right: 0.17rem;
    bottom: 1.5rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      display: block;
    }
  }
}
</style>

<style lang="scss">
.container {
  &.ylcontainer {
    .van-checkbox__icon--checked .van-icon {
      color: #780700;
    }
    .van-checkbox__icon .van-icon {
      background: #fff;
    }
    .van-checkbox__icon--disabled .van-icon {
      background: #eee;
    }
    .van-checkbox__icon--round .van-icon {
      border: solid 1px #e5e5e5;
    }
    .van-radio__icon--checked .van-icon {
      color: #780700;
    }
    .van-radio__icon .van-icon {
      background: #fff;
    }
    .van-radio__icon--disabled .van-icon {
      background: #eee;
    }
    .van-radio__icon--round .van-icon {
      border: solid 1px #e5e5e5;
    }
    .img-icon {
      height: 0.17rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/giftactpage/jzdzlbindex.vue